import {
  AlertCircleIcon,
  Cancel01Icon,
  Mail01Icon,
  MoneyExchange01Icon,
  PrisonerIcon,
  SmartPhone01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Badge,
  BadgeSize,
  BadgeVariant,
  IconButton,
  IconButtonSize
} from "shared/components";
import { Banner } from "shared/components/Banner";
import { formatToCurrency } from "shared/utils";

interface Props {
  applicantFullName: string;
  applicantRole: string;
  email: string;
  phone: string;
  cents: number;
  onClose: () => void;
}

export const IntroView = ({
  applicantFullName,
  applicantRole,
  email,
  phone,
  cents,
  onClose
}: Props) => (
  <div className="p-6 relative">
    <IconButton
      HugeIcon={Cancel01Icon}
      size={IconButtonSize.SM}
      borderLess
      className="absolute top-4 right-4"
      onClick={onClose}
    />

    <div className="bg-primary-20 h-20 w-20 rounded-full flex items-center justify-center mx-auto mb-6">
      <HugeiconsIcon
        icon={MoneyExchange01Icon}
        size={32}
        className="text-primary-500"
      />
    </div>

    <h1 className="text-xl text-content-1000 font-bold mb-2 text-center">
      Run new income report
    </h1>
    <p className="pb-6 border-b border-alpha-40 text-center text-sm font-medium text-content-300 max-w-[400px] mx-auto">
      Boom will send an income re-verification request to the applicant via
      email and SMS
    </p>

    <div className="mt-6 pb-[18px] mb-6 border-b border-alpha-40 space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-content-400">
        <HugeiconsIcon icon={PrisonerIcon} size={20} className="shrink-0" />
        <p>Person</p>
        <p className="ml-auto">{`${applicantFullName}, ${applicantRole}`}</p>
      </div>

      <div className="flex items-center gap-2 text-sm font-medium text-content-400">
        <HugeiconsIcon icon={Mail01Icon} size={20} className="shrink-0" />
        <p>Email</p>
        <p className="ml-auto">{email || "-"}</p>
      </div>

      <div className="flex items-center gap-2 text-sm font-medium text-content-400">
        <HugeiconsIcon icon={SmartPhone01Icon} size={20} className="shrink-0" />
        <p>Phone</p>
        <p className="ml-auto">{phone || "-"}</p>
      </div>
    </div>

    <div className="flex justify-between text-base font-bold mb-6">
      <p className="text-content-1000">Verification cost</p>

      <Badge
        className="!font-bold px-[10px] py-[2px] text-content-700"
        size={BadgeSize.SM}
        borderless={false}
        variant={BadgeVariant.BASE}
      >
        <span className="text-sm">
          {formatToCurrency(
            {
              cents,
              currency: "USD"
            },
            {
              minimumFractionDigits: 2
            }
          )}
        </span>
      </Badge>
    </div>

    <Banner
      textTheme="colorful"
      variant="warning"
      HugeIcon={
        <HugeiconsIcon
          icon={AlertCircleIcon}
          className="text-warning-500"
          size={20}
        />
      }
      body="You will be charged an additional fee once the verification is successfully completed"
    />
  </div>
);
